import React from "react";
import generatePDF, { Margin } from "react-to-pdf";
import Button from "@/components/settings/Button";
import { t } from "@/localization";

const PDFExportButton = ({ event, contentRef }) => {
  const handleExportPDF = async () => {
    if (!contentRef?.current) {
      console.error("Content reference is not available");
      return;
    }

    try {
      await generatePDF(contentRef, {
        filename: event?.title
          ? t("{title}-report.pdf", { title: event.title })
          : t("analytics-report.pdf"),
        page: {
          // margin is in MM, default is Margin.NONE = 0
          margin: Margin.MEDIUM,
          // default is 'A4'
          format: "letter",
        },
      });
    } catch (err) {
      console.error("Failed to generate PDF:", err);
    }
  };

  return (
    <Button
      text={t("Export PDF")}
      icon="download-outline"
      size="sm"
      fullWidth={false}
      onPress={handleExportPDF}
    />
  );
};

export default PDFExportButton;
